var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"odr-main odr-main_chat",attrs:{"lang":"mix","data-odr-widget":_vm.$root.id,"data-qa":"odoro.widget"}},[_c('keep-alive',[(_vm.chatVars.opened)?_c('chat',{on:{"close":_vm.close}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }